// Interval class.
export class Interval {
	constructor(properties, fn) {
		if (!fn) {
			throw Error('No function given to Interval.')
		}

		const settings = properties || {}
		const autostart = settings.autostart !== undefined ? settings.autostart : true
		this.delay = settings.delay || 0
		this.duration = settings.duration || 1000
		this.fps = settings.fps || 60
		this.loop = settings.loop || false

		this.fn = fn

		if (autostart) {
			this.start()
		}
	}

	restart() {
		return this.stop().start()
	}

	start() {
		if (this.interval) {
			return this
		}
		
		const startTime = Date.now() + this.delay
		const frameDuration = 1000 / this.fps
		const step = frameDuration / this.duration
		let position = 0

		this.interval = setInterval(() => {
			const now = Date.now()

			if (startTime > now) {
				return
			}

			position = Math.min(position + step, 1)
			this.fn.call(this, position)

			if (position >= 1) {
				if (this.loop) {
					this.restart()
				}
				else {
					this.stop()
				}
			}
		}, frameDuration)

		return this
	}

	stop() {
		this.interval = clearInterval(this.interval)
		return this
	}

	get isRunning() {
		return !!this.interval
	}
}